// extracted by mini-css-extract-plugin
export var borderRadius = "_c7-4";
export var large = "_c7-3";
export var logoContainer = "_c7-0";
export var nameLogo = "_c7-2";
export var small = "_c7-1";